module.exports = __webpack_public_path__ + "img/12-consumers-laserbeamer.png";